<template>
  <section class="row">
    <article class="col-12">
      <div @click.stop.prevent="() =>
        $router.push({
          path: `/university-about/${item.university_id}`
        })
        " class="course-provider">
        <section class="row mb-1 align-items-center">
          <article class="col-md-2">
            <figure>
              <!-- item.university_logo -->
              <img :src="IMAGEURL + item.university_logo" alt="" class="w-100 university-logo" />
            </figure>
          </article>
          <article class="col-md-10">
            <div class="mb-1 d-flex align-items-center justify-content-between flex-wrap">
              <span class="course-provider__name">{{
                item.university_name
                }}</span>
              <div class="d-flex align-items-center">
                <span v-if="item.rating_stars" class="course-provider__point mr-3">
                  <img v-for="(item, index) in parseInt(item.rating_stars)" :key="'star_' + index"
                    src="@/assets/imgs/svgs/star-yellow.svg" alt="" />
                  <!-- ISC Rank - <b>{{ item.global_rank }}</b> -->
                </span>
                <span class="course-provider__point">
                  <!-- <img
                    src="@/assets/imgs/svgs/add-to-profile.svg"
                    alt=""/>
                    Acceptance Rate &nbsp;
                  <b>{{ item.acceptens_rate }}%</b> -->
                </span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <span class="course-provider__point">
                <img src="@/assets/imgs/svgs/location.svg" alt="" />
                {{ item.country_name }}, {{ item.state_name }}
              </span>
              <span class="course-provider__point">
                <img src="@/assets/imgs/svgs/location.svg" alt="" />
                {{ item.city_name }}
              </span>
            </div>
          </article>
        </section>
        <div v-if="item.courses && item.courses.length > 0" class="course-provider__courses">
          <div v-for="i in item.courses" :key="'course_id_' + i.course_id" @click.stop.prevent="gotToCourseDetails(i)">
            <Course :course="i" />
          </div>
        </div>
        <div v-if="item.course_ids && item.course_ids.split(',').length > 2"
          class="text-center course-provider__bottom mt-4">
          <b-button @click.stop.prevent="() =>
            $router.push({
              path: `/university-about/${item.university_id}`
            })
            " variant="outline-primary" size="sm">
            VIEW {{ item.course_ids.split(",").length }} MORE COURSES
          </b-button>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import Course from "./Course";
import { IMAGEURL } from "@/config";
export default {
  name: "CourseProvider",
  components: {
    Course
  },
  data() {
    return {
      IMAGEURL,
    };
  },
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  methods: {
    gotToCourseDetails(course) {
      this.$router.push({
        path: `/university-about/${course.university_id}?course_id=${course.course_id}`
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Search/helper/CourseProvider.vue